export default __webpack_public_path__ + "static/media/interface-14.2af69827.png";